module.exports = __webpack_public_path__ + "static/media/bell-check.79feaa13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/bell-check.svg
// module id = 2403
// module chunks = 7